import { Component } from '@angular/core';

@Component({
    selector: 'app-adnavem-logo',
    templateUrl: 'AdnavemLogoComponent.html',
    standalone: false
})
export class AdnavemLogoComponent {

}
